import { Flex, Skeleton } from "antd"

import styles from "./styles.module.less"

// Скелетон повторює лейаут `LookupCard`: 3 ряди по 2 елементи, 4 — з рядом деталей.
const ReceiptLookupCardSkeleton = ({ withDetails }) => (
  <Flex vertical gap={8} className={styles.card}>
    <Flex justify="space-between" align="center">
      <Skeleton.Button active size="small" style={{ width: 96, height: 16 }} />
      <Skeleton.Button active size="small" style={{ width: 64, height: 22, borderRadius: 6 }} />
    </Flex>
    <Flex justify="space-between" align="center">
      <Skeleton.Button active size="small" style={{ width: 72, height: 16 }} />
      <Skeleton.Button active size="small" style={{ width: 56, height: 16 }} />
    </Flex>
    {withDetails && (
      <Flex justify="space-between" align="center">
        <Skeleton.Button active size="small" style={{ width: 120, height: 16 }} />
        <Skeleton.Button active size="small" style={{ width: 88, height: 24, borderRadius: 6 }} />
      </Flex>
    )}
    <Flex justify="space-between" align="center">
      <Skeleton.Button active size="small" style={{ width: 88, height: 22, borderRadius: 6 }} />
      <Skeleton.Button active size="small" style={{ width: 64, height: 14 }} />
    </Flex>
  </Flex>
)

export default ReceiptLookupCardSkeleton
